export default __webpack_public_path__ + "static/media/create_nft_bg.4d3148a8.png";